import React from 'react';
import {
  TextField,
  TextAreaField,
  SelectField,
  CheckboxField,
  RadioField,
  DateField,
  FileUploadField,
  OpinionScaleField,
  NPSField,
  RatingField,
  PictureChoiceField,
  YesNoField,
  StatementField,
  WelcomeScreenField,
  ThankYouScreenField,
  RedirectUrlField,
} from '../components/forms/fields';
import type { FormField, ThemeConfig } from '../types/forms';

export const renderFieldPreview = (field: FormField, themeConfig?: ThemeConfig): React.ReactNode => {
  const props = { field, disabled: true, themeConfig };

  switch (field.type) {
    case 'text':
    case 'email':
    case 'phone':
    case 'url':
    case 'number':
      return <TextField {...props} />;
    case 'textarea':
      return <TextAreaField {...props} />;
    case 'select':
      return <SelectField {...props} />;
    case 'checkbox':
      return <CheckboxField {...props} value={[]} />;
    case 'radio':
      return <RadioField {...props} />;
    case 'date':
    case 'datetime':
    case 'time':
      return <DateField {...props} />;
    case 'file':
      return <FileUploadField {...props} />;
    case 'heading':
      return <h3 className="text-xl font-bold" style={{ color: 'inherit' }}>{field.label}</h3>;
    case 'paragraph':
      return <p style={{ color: 'inherit', opacity: 0.6 }}>{field.placeholder || 'Texto do parágrafo...'}</p>;
    case 'opinion_scale':
      return <OpinionScaleField {...props} />;
    case 'nps':
      return <NPSField {...props} />;
    case 'rating':
      return <RatingField {...props} />;
    case 'picture_choice':
      return <PictureChoiceField {...props} />;
    case 'yes_no':
      return <YesNoField {...props} />;
    case 'statement':
      return <StatementField {...props} />;
    case 'welcome_screen':
      return <WelcomeScreenField {...props} />;
    case 'thank_you_screen':
      return <ThankYouScreenField {...props} />;
    case 'redirect_url':
      return <RedirectUrlField {...props} />;
    default:
      return <TextField {...props} />;
  }
};
